import { ArrowLeft2 } from 'iconsax-react';
import Link from 'next/link';

import { TInvestmentBannerProps } from '../model';

export function InvestmentBanner(props: TInvestmentBannerProps) {
  const content = (
    <>
      <div
        className='absolute inset-0 bg-cover bg-center'
        style={{ backgroundImage: `url(${props.backgroundImage})` }}
      />

      <div className='relative flex w-full flex-col px-4 py-4 justify-between'>
        <div className='flex flex-col'>
          <div className='flex items-center justify-between gap-4'>
            <div className='flex flex-col gap-3 max-w-[260px]'>
              <button className='size-[36px] rounded-[12px] bg-white p-[6px]'>{props.icon}</button>
              <p className='text-sm font-bold'>{props.title}</p>
              <p className='text-xs opacity-90 text-wrap leading-[20px]'>{props.description}</p>
            </div>
            <div
              className='size-[85px] bg-cover bg-center flex-shrink-0'
              style={{ backgroundImage: `url(${props.image})` }}
            />
          </div>
        </div>

        <div className='flex items-center justify-between'>
          <div className='flex flex-wrap items-center gap-[10px] max-w-[260px]'>
            {props.tags &&
              props.tags.map((tag, index) => (
                <span
                  key={`${tag.title}-${index}`}
                  className='flex  items-center gap-1 rounded-[6px] bg-white px-2 py-1 text-[12px] font-semibold text-[#323E54]'
                >
                  {tag.bulletColorClass && (
                    <span className={`size-[5px] rounded-full ${tag.bulletColorClass}`} />
                  )}
                  {tag.title}
                </span>
              ))}
          </div>

          <button className='rounded-[8px] bg-white p-[6px]'>
            <ArrowLeft2 size={20} className='text-[#323E54]' />
          </button>
        </div>
      </div>
    </>
  );

  if (props.isExternal) {
    return (
      <a
        href={props.href}
        target='_blank'
        className='relative flex h-[228px] w-full overflow-hidden rounded-xl text-white'
      >
        {content}
      </a>
    );
  }

  return (
    <Link
      href={props.href}
      className='relative flex h-[228px] w-full overflow-hidden rounded-xl text-white'
    >
      {content}
    </Link>
  );
}
